import React from 'react';

import * as S from './styled';

const ProductSummaryBanner = ({ data, title, subtitle }) => (
  <S.StyledBanner title={title} subtitle={subtitle} bold={false}>
    <S.BannerContentColumns>
      <S.ColumnWrapper>
        <S.ColumnContent title="Seu produto" content="Cap ganhador" text flex />
      </S.ColumnWrapper>
      <S.ColumnWrapper>
        <S.ColumnContent
          title="Qtd. de títulos"
          content={data.titulo}
          className="biggerContent"
          text
          flex
        />
      </S.ColumnWrapper>
      <S.ColumnWrapper>
        <S.TitledCurrency
          title="Você irá pagar"
          content={
            <>
              {data.titulo * data.valor}
              <small>,00</small> <span>/mês</span>
            </>
          }
          className="biggerContent"
          text
          flex
        />
      </S.ColumnWrapper>
    </S.BannerContentColumns>
  </S.StyledBanner>
);

export default ProductSummaryBanner;
